import { useEffect } from 'react';
import isFunction from 'lodash/isFunction';

type OptionsType = {
  checkExists?: boolean;
  onLoaded?: () => void;
  isModule?: boolean;
};

const useScriptInvoked = (
  url: string | null,
  { checkExists, onLoaded, isModule }: OptionsType = { checkExists: true }
): void => {
  useEffect(() => {
    let script: HTMLScriptElement | undefined;

    if (url) {
      if (checkExists && document.querySelector(`script[src="${url}"]`)) {
        if (isFunction(onLoaded)) {
          onLoaded();
        }
      } else {
        script = document.createElement('script');

        if (isFunction(onLoaded)) {
          script.onload = onLoaded;
        }

        script.src = url;
        script.async = true;

        if (isModule) {
          script.type = 'module';
        }

        document.body.appendChild(script);
      }
    }

    return () => {
      if (script) {
        document.body.removeChild(script);
      }
    };
  }, [checkExists, isModule, onLoaded, url]);
};

export default useScriptInvoked;
